import { createFileRoute, Link } from "@tanstack/react-router";
import { useProjectContext } from "~/components/layout/project-context";
import { ScreeningEmptyState } from "~/components/screening/screening-empty-state";
import { Button } from "~/components/ui/button";

export const Route = createFileRoute(
  "/_auth/projects/$projectId/screening/full-text/review",
)({
  component: FullTextReviewPage,
});

function FullTextReviewPage() {
  const { projectId, projectTitle } =
    useProjectContext();
  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex-1 px-6 py-10">
        <ScreeningEmptyState
          title="Nothing to screen right now"
          description="Full-text review is not enabled in this testing phase."
          actions={
            <Button
              render={
                <Link to="/projects/$projectId" params={{ projectId }} />
              }
            >
              Return to Project
            </Button>
          }
        />
      </main>
    </div>
  );
}
